/* istanbul ignore file */
import { useOpportunityId } from 'domain/shared/opportunity';
import useContractRequestService from 'domain/sales/opportunity/presale/contract/shared/contractRequestService';
import { UpdateForm } from 'framework/form';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import ContractRequestForm from 'domain/sales/opportunity/presale/contract/form/ContractRequestForm';
import { useCompositeDocumentStorageContext, useCompositeDocumentStorageService } from 'domain/shared/documentStorage';
import { ENTITY_DOCUMENT_TYPE } from 'domain/sales/opportunity/shared/constants';

const UpdateContractRequestForm = ({ getDataFunc, onCancel, ...props }: any) => {
  const opportunityId = useOpportunityId();
  const { update, getValidationSchema } = useContractRequestService();
  const { isDocumentStorageAvailable } = useCompositeDocumentStorageContext();
  const { commitDocument } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={async (id, data) => {
        const artifactPath = data?.artifactPaths;
        const commitData = await commitDocument(artifactPath, ENTITY_DOCUMENT_TYPE.CONTRACT_REQUEST_DOCUMENT);
        return update(opportunityId, id, { ...data, artifactPaths: commitData });
      }}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <ContractRequestForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateContractRequestForm;
